module.exports = "uniform sampler2D uTexture;\n\nvarying vec3 vPosition;\nvarying vec2 vUv;\nvarying float vAlpha;\nvarying float vBlue;\n\nvoid main()\n{\n    // Original texture\n    vec4 texture = texture2D(uTexture, vUv);\n    texture.rgb = clamp(texture.rgb, vec3(0.0), vec3(1.0));\n\n    // Alpha\n    texture.a *= vAlpha;\n\n    // Blue\n    texture.r -= vBlue;\n    texture.g -= vBlue * 0.35;\n\n    gl_FragColor = texture;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/libs/experience/shaders/models/fragment.glsl
// module id = 408
// module chunks = 0